import store from "@/store";

export const homeOtherComUseLayerGroupCreate = () => {
  const homeMap = store.getters.getHomeMap,
    layerGroup = L.featureGroup();
  if (homeMap) {
    homeMap.eachLayer(layer => {
      if (layer['options'] && layer['options']['otherComUse']) {
        let copyLayer;
        if (layer instanceof L.Marker) {
          copyLayer = L.marker(layer.getLatLng(), { ...layer.options });
        } else if (layer instanceof L.Polygon) {
          copyLayer = L.polygon(layer.getLatLngs(), { ...layer.options });
        } else if (layer instanceof L.CircleMarker) {
          copyLayer = L.circleMarker(layer.getLatLng(), { ...layer.options });
        } else if (layer instanceof L.Polyline) {
          copyLayer = L.polyline(layer.getLatLngs(), { ...layer.options });
        }
        if (!copyLayer) return;
        const tooltip = layer.getTooltip();
        tooltip && copyLayer.bindTooltip(tooltip['_content'], {
          ...tooltip['options'],
        })
        copyLayer && layerGroup.addLayer(copyLayer);
      }
    })
  }
  return layerGroup;
}
